/**
 * iOS / iPadOS detection. iPadOS 13+ reports a desktop Safari user-agent
 * ("Macintosh"), so a touch-capable Mac is treated as an iPad.
 *
 * Used to bypass the Web Audio API on iOS: routing an <audio> element through an
 * AudioContext means playback stops when the PWA is backgrounded (iOS suspends
 * the context). A bare element keeps playing in the background, at the cost of
 * crossfade / ReplayGain / the beat-pulse visualizer.
 */
export function isIOS(): boolean {
  if (typeof navigator === 'undefined') return false
  const ua = navigator.userAgent
  return /iPad|iPhone|iPod/.test(ua) || (ua.includes('Macintosh') && navigator.maxTouchPoints > 1)
}
